






















import { Component, Vue } from 'vue-property-decorator'
import LocaleHelper from '@/utils/LocaleHelper'
import { LocaleData } from '@/interfaces/UserInterfaces'
import { Locale } from '@/interfaces/Locale'
import { EventBus } from '@/main'

@Component({ name: 'LangSwitcher' })
export default class LangSwitcher extends Vue {
  currentLocale: Locale | null = { locale: '', localeName: '' }
  availableLocales: LocaleData[] = []

  created () {
    EventBus.$on('languageChanged', (changedLanguage: string) => {
      if (!LocaleHelper.getDefaultLocale()) {
        const locale = this.availableLocales.find(lang => lang.locale === changedLanguage) || this.availableLocales.find(lang => lang.locale === 'ar')

        if (locale && this.currentLocale && locale.locale !== this.currentLocale.locale) {
          this.changeLocale(locale)
        }
      }
    })

    let locale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ar'
    this.availableLocales = LocaleHelper.availableLocalesData
    locale = LocaleHelper.getUserLocale()
    this.currentLocale = this.availableLocales.find(lang => lang.locale === locale) || null
  }

  changeLocaleSwitcher (locale: Locale) {
    LocaleHelper.setDefaultLocale(locale.locale)
    this.changeLocale(locale)
  }

  private changeLocale (locale: Locale) {
    this.currentLocale = locale
    LocaleHelper.setUserLocale(this.currentLocale.locale)
    window.location.reload()
  }
}
